import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default el => {
    const prev = el.querySelector('.prev');
    const next = el.querySelector('.next');
    const paging = el.querySelector('.paging');

    const args = {
        slidesPerView: el.dataset.slidesPerView ? el.dataset.slidesPerView : 1.25,
        modules: [Navigation, Pagination],
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
            // 575: {
            //   slidesPerView: 1.5
            // },
            // 600: {
            //     slidesPerView: 2.15
            // },
            768: {
                slidesPerView: el.dataset.slidesPerViewMd ? el.dataset.slidesPerViewMd : 2.25,
            },
            1200: {
                slidesPerView: el.dataset.slidesPerViewLg ? el.dataset.slidesPerViewLg : 3,
            },
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        pagination: {
            el: paging,
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            },
        },
    }

    const swiper = new Swiper(el, args);
};
